import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Box,
  useTheme,
  useMediaQuery,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../assets/images/tsj-logo.png';
import { useAuth } from '../context/AuthContext';
import { hasAnyRole, UserRole } from '../types/user';

const Header: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { user, logout } = useAuth();
  const canAccessAdmin = hasAnyRole(user, [UserRole.ADMIN, UserRole.EDITOR]);
  const canAccessAuthor = hasAnyRole(user, [UserRole.AUTHOR, UserRole.ADMIN]);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleClose();
  };

  const menuItems = [
    { text: 'Главная', path: '/' },
    { text: 'Выпуски', path: '/issues' },
    { text: 'Статьи', path: '/articles' },
    { text: 'Авторам', path: '/authors' },
    { text: 'Редакция', path: '/editorial-board' },
    { text: 'Контакты', path: '/contacts' },
  ];

  return (
    <AppBar position="static">
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <Box
            component={RouterLink}
            to="/"
            sx={{
              flexGrow: 1,
              textDecoration: 'none',
              color: 'inherit',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img 
              src={logo} 
              alt="ТНЖ" 
              style={{ 
                height: '50px',
                marginRight: '10px'
              }} 
            />
            <Typography variant="h6" sx={{ display: { xs: 'none', sm: 'block' } }}>
              Тюменский научный журнал
            </Typography>
            <Typography variant="caption" sx={{ display: { xs: 'none', sm: 'block' }, ml: 1, opacity: 0.8 }}>
              ISSN: 3034-154Х
            </Typography>
          </Box>

          {isMobile ? (
            <>
              <IconButton
                size="large"
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={handleMenu}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                {menuItems.map((item) => (
                  <MenuItem
                    key={item.path}
                    onClick={handleClose}
                    component={RouterLink}
                    to={item.path}
                  >
                    {item.text}
                  </MenuItem>
                ))}
                {canAccessAdmin && (
                  <MenuItem
                    onClick={handleClose}
                    component={RouterLink}
                    to="/admin"
                  >
                    Панель администратора
                  </MenuItem>
                )}
                {canAccessAuthor && (
                  <MenuItem
                    onClick={handleClose}
                    component={RouterLink}
                    to="/author"
                  >
                    Кабинет автора
                  </MenuItem>
                )}
                {/* Личный кабинет обычных пользователей отключен */}
                {/* {user && (user.role === 'user' || user.role === 'admin') && (
                  <MenuItem
                    onClick={handleClose}
                    component={RouterLink}
                    to="/profile"
                  >
                    Личный кабинет
                  </MenuItem>
                )} */}
                {user ? (
                  <MenuItem
                    onClick={handleLogout}
                  >
                    Выйти
                  </MenuItem>
                ) : (
                <MenuItem
                  onClick={handleClose}
                  component={RouterLink}
                  to="/login"
                >
                  Войти
                </MenuItem>
                )}
              </Menu>
            </>
          ) : (
            <Box sx={{ display: 'flex', gap: 2 }}>
              {menuItems.map((item) => (
                <Button
                  key={item.path}
                  color="inherit"
                  component={RouterLink}
                  to={item.path}
                >
                  {item.text}
                </Button>
              ))}
              {canAccessAdmin && (
                <Button
                  color="inherit"
                  component={RouterLink}
                  to="/admin"
                  sx={{ ml: 2 }}
                >
                  Панель администратора
                </Button>
              )}
              {canAccessAuthor && (
                <Button
                  color="inherit"
                  component={RouterLink}
                  to="/author"
                  sx={{ ml: 2 }}
                >
                  Кабинет автора
                </Button>
              )}
              {/* Личный кабинет обычных пользователей отключен */}
              {/* {user && (user.role === 'user' || user.role === 'admin') && (
                <Button
                  color="inherit"
                  component={RouterLink}
                  to="/profile"
                  sx={{ ml: 2 }}
                >
                  Личный кабинет
                </Button>
              )} */}
              {user ? (
                <Button
                  color="inherit"
                  variant="outlined"
                  onClick={handleLogout}
                  sx={{ ml: 2 }}
                >
                  Выйти
                </Button>
              ) : (
              <Button
                color="inherit"
                variant="outlined"
                component={RouterLink}
                to="/login"
                sx={{ ml: 2 }}
              >
                Войти
              </Button>
              )}
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header; 